import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const useRouteListener = (routeMatchRegex, onRouteMatch, depsArray) => {
  const location = useLocation();

  // const unListen = navigate.listen(() => {
  //   const match = navigate.location.pathname.match(routeMatchRegex);
  //   if (match) {
  //     const resourceId = match[1];
  //     onRouteMatch(resourceId);
  //   }
  // });

  useEffect(() => {
    const match = location.pathname.match(routeMatchRegex);
    if (match) {
      const resourceId = match[1];
      onRouteMatch(resourceId);
    }
  }, [depsArray, location, onRouteMatch, routeMatchRegex]);
};

export default useRouteListener;
